module.exports = __webpack_public_path__ + "img/guide_start.d4f87b84.png";